import { SVGProps } from 'react';

const PNLAnalyticsLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    data-palette="PNLAnalyticsLight">
    <path
      d="M9.00008 17.3333C4.39758 17.3333 0.666748 13.6025 0.666748 9C0.666748 5.26833 3.11925 2.11 6.50008 1.04833V2.81833C5.06752 3.40004 3.88158 4.46142 3.14513 5.82093C2.40868 7.18044 2.16748 8.75359 2.46279 10.2713C2.7581 11.789 3.57157 13.1569 4.76405 14.1411C5.95653 15.1253 7.45392 15.6646 9.00008 15.6667C10.3282 15.6666 11.6261 15.27 12.7275 14.5277C13.8288 13.7854 14.6834 12.7311 15.1817 11.5H16.9517C15.8901 14.8808 12.7317 17.3333 9.00008 17.3333ZM17.2917 9.83333H8.16675V0.708333C8.44091 0.680833 8.71925 0.666666 9.00008 0.666666C13.6026 0.666666 17.3334 4.3975 17.3334 9C17.3334 9.28083 17.3192 9.55917 17.2917 9.83333ZM9.83341 2.385V8.16666H15.6151C15.4296 6.698 14.7608 5.33278 13.7141 4.28603C12.6673 3.23928 11.3021 2.57049 9.83341 2.385Z"
      fill="currentColor"
      stroke="var(--main-bg-surface)"
      strokeWidth="0.4"
    />
  </svg>
);

export default PNLAnalyticsLight;
